import { useTranslation } from 'react-i18next'
import { CheckCircle2, Circle } from 'lucide-react'
import { Card, CardContent } from '@/components/v2/ui'

interface ReadinessRingCardProps {
  progressPercent: number
  steps: Array<{ label: string; done: boolean }>
}

const CIRCUMFERENCE = 314

export function ReadinessRingCard({ progressPercent, steps }: ReadinessRingCardProps) {
  const { t } = useTranslation()
  const offset = CIRCUMFERENCE - (CIRCUMFERENCE * progressPercent) / 100

  return (
    <Card className="product-overview-readiness">
      <CardContent className="p-7">
        <h3 className="mb-5 text-sm font-semibold text-neutral-900 dark:text-neutral-100">
          {t('products.readiness.title')}
        </h3>

        <div className="flex justify-center">
          <svg className="h-32 w-32" viewBox="0 0 120 120">
            <circle
              cx={60}
              cy={60}
              r={50}
              fill="none"
              stroke="currentColor"
              strokeWidth={10}
              className="text-neutral-200 dark:text-neutral-700"
            />
            <circle
              cx={60}
              cy={60}
              r={50}
              fill="none"
              stroke="currentColor"
              strokeWidth={10}
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={offset}
              strokeLinecap="round"
              transform="rotate(-90 60 60)"
              className="text-amber-500 transition-all"
            />
            <text
              x={60}
              y={55}
              textAnchor="middle"
              className="fill-neutral-900 text-2xl font-bold dark:fill-neutral-100"
            >
              {progressPercent}%
            </text>
            <text
              x={60}
              y={72}
              textAnchor="middle"
              className="fill-neutral-500 text-xs dark:fill-neutral-400"
            >
              {t('products.readiness.ready')}
            </text>
          </svg>
        </div>

        <ul className="mt-6 space-y-3.5">
          {steps.map((step) => (
            <li key={step.label} className="flex items-center gap-2.5">
              {step.done ? (
                <CheckCircle2 className="h-4 w-4 shrink-0 text-green-500" />
              ) : (
                <Circle className="h-4 w-4 shrink-0 text-neutral-300 dark:text-neutral-600" />
              )}
              <span className="text-sm text-neutral-700 dark:text-neutral-300">
                {step.label}
              </span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
